import {IsArray, IsString} from 'class-validator';

export class WorkspaceMarkSeenDto {
  @IsArray()
  @IsString({each: true})
  workspaceIds!: string[];
}
